/*
 * @Author: sipeng
 * @LastEditTime: 2022-09-14 15:18:23
 * @Description:
 * @LastEditors: Please set LastEditors
 */
import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from '@/services/instance'

export default class AccessControlSecurity {
  // 获取门禁列表
  static async getAccessControl(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/hikvision/door/event', payload))
    return Callback(err, res)
  }
  // 获取门禁点列表v2
  static async getAccessControlListV2() {
    const [err, res] = await To(wizStandardInstance.get('/api/hikvision/accesslist'))
    return Callback(err, res)
  }
  // 获取车辆查询列表
  static async getCarQuery(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/hikvision/crossrecord', payload))
    return Callback(err, res)
  }
  // 获取周界安防查询列表
  static async getPerimeterSecurityQuery(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/hikvision/eventlogs', payload))
    return Callback(err, res)
  }
  // 获取门禁关联列表
  static async getAccessControlRelationList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/access_tag_relation/page-list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取门禁模型导入模板
  static async getAccessControlRelationTemplate() {
    const [err, res] = await To(
      wizStandardInstance.get('/api/access_tag_relation/template_download')
    )
    return Callback(err, res)
  }
  // 门禁模型导入
  static async uploadAccessControlRelation(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/access_tag_relation/import', payload.formData)
    )
    return Callback(err, res)
  }
  // 修改门禁关联模型
  static async editAccessRelation(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/access_tag_relation/customer-update', payload)
    )
    return Callback(err, res)
  }
  // 新增门禁关联
  static async addAccessRelation(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/access_tag_relation/customer-add', payload)
    )
    return Callback(err, res)
  }
  // 删除门禁关联
  static async deleteAccessRelation(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/access_tag_relation/batch-delete', payload)
    )
    return Callback(err, res)
  }
  // 获取模型关联的门禁列表
  static async getRelationAccessByDocId(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/access_tag_relation/door-list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取门禁状态
  static async getAccessState(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/hikvision/accessstatelist?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取区域数据
  // static async getregionList(payload) {
  //   const [err, res] = await To(wizStandardInstance.post('/api/hikvision/region/tree', payload))
  //   return Callback(err, res)
  // }
}
